import { Select } from './Select';
import { InputWrapper } from 'components/InputWrapper';

export const SelectWithLabel = <V extends Record<string, any>>(props: {
  labelText: React.ReactNode;
  name: string;
  items: V[];
  selectedItem: V | null;
  onSelect: (value: V | null) => void;
  keyName: string;
  display: (value: V) => string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  onBlur?: () => void;
  isOptional?: boolean;
}) => {
  const {
    labelText,
    name,
    items,
    selectedItem,
    onSelect,
    keyName,
    display,
    isDisabled,
    isInvalid,
    onBlur,
    isOptional,
  } = props;

  return (
    <InputWrapper labelText={labelText} invalidText={isInvalid ? 'Ongeldige selectie' : undefined}>
      <Select<V>
        placeholder={name}
        items={items}
        selectedItem={selectedItem}
        onSelect={onSelect}
        keyName={keyName}
        display={display}
        isDisabled={isDisabled}
        isInvalid={isInvalid}
        onBlur={onBlur}
        isOptional={isOptional}
      />
    </InputWrapper>
  );
};
